import { render } from "./SouthAfricaChapter.vue?vue&type=template&id=507e6abc"
import script from "./SouthAfricaChapter.vue?vue&type=script&lang=js"
export * from "./SouthAfricaChapter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__